/**
 * Panorama Library — BARE MC
 * ─────────────────────────────────────────────────────────────────────────────
 * Eneste kilde til baggrundsbilleder i JourneyTimeline.
 * Tilføj nye panoramaer i PANORAMAS-objektet.
 * Skift aktivt panorama ved at ændre ACTIVE_PANORAMA_ID.
 * JourneyTimeline og replay-systemet behøver aldrig ændres for at skifte panorama.
 *
 * REGLER — gælder alle panoramaer i biblioteket:
 *   - Ingen CSS-filtre
 *   - Ingen mørke overlays
 *   - Ingen gradients
 *   - Ingen blur
 *   - Ingen farvejustering
 *   - Ingen automatisk beskæring eller skalering der ændrer billedets udseende
 *   - Billeder vises 1:1, præcis som de er gemt
 * ─────────────────────────────────────────────────────────────────────────────
 */

/**
 * PANORAMAS — fuldt bibliotek over godkendte panoramaer.
 * Hvert panorama har:
 *   id          — unik nøgle (bruges af ACTIVE_PANORAMA_ID)
 *   file        — sti fra /public (bruges direkte som CSS background-image)
 *   label       — menneskevenlig beskrivelse
 *   nativeWidth — billedets native bredde i px (bruges til side-scroll)
 *   nativeHeight — billedets native højde i px (skal passe til LAND_H=104)
 *   skyColor    — CSS-farve der matcher panoramaets øverste himmel.
 *                 Bruges som baggrundslag bag kortets bund-fade i RideReplayPlayer
 *                 så overgangen er lys og naturlig — ikke mørk.
 */
export const PANORAMAS = {
  user_custom: {
    id: 'user_custom',
    file: '/assets/panoramas/approved/panorama_user_custom.png',
    label: 'Godkendt brugerpanorama — bjerg, sø og vej (golden hour)',
    nativeWidth: 1264,
    nativeHeight: 104,
    // Gennemsnitsfarve af panoramaets øverste 10px: R=115 G=134 B=157
    skyColor: 'rgb(115, 134, 157)',
  },
  // Fremtidige panoramaer tilføjes her, f.eks.:
  // danish_coast: {
  //   id: 'danish_coast',
  //   file: '/assets/panoramas/approved/panorama_danish_coast.jpg',
  //   label: 'Dansk kyst + fjord',
  //   nativeWidth: 1264,
  //   nativeHeight: 104,
  //   skyColor: 'rgb(140, 175, 200)',
  // },
};

/**
 * ACTIVE_PANORAMA_ID — det panorama som JourneyTimeline viser.
 * Ændr denne én linje for at skifte panorama i hele appen.
 */
export const ACTIVE_PANORAMA_ID = 'user_custom';

/**
 * getActivePanorama() — returnerer det aktive panorama-objekt.
 * Brug denne i JourneyTimeline og andre komponenter.
 */
export function getActivePanorama() {
  const pano = PANORAMAS[ACTIVE_PANORAMA_ID];
  if (!pano) {
    // Fallback hvis ACTIVE_PANORAMA_ID peger på et ikke-eksisterende panorama
    const first = Object.values(PANORAMAS)[0];
    if (!first) throw new Error('[PanoramaLibrary] Ingen panoramaer defineret.');
    return first;
  }
  return pano;
}

/**
 * getPanoramaCSS(pano) — returnerer CSS background-image string klar til brug.
 * Ingen filtre, ingen modifikationer — ren URL.
 */
export function getPanoramaCSS(pano) {
  return `url('${pano.file}')`;
}
